class UserInputStore {
  constructor() {
    /**
     * @type {Userdata}
     */
    this.userInput = [];
  }

  setUserInput(userInput) {
    this.userInput = userInput;
  }

  getUserInput() {
    return this.userInput;
  }
}

export const UserInputStoreInstance = new UserInputStore();
